export enum SpaceFileMimeType {
  CSV = 'text/csv',
  DOC = 'application/msword',
  DOCX = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  JPEG = 'image/jpeg',
  PDF = 'application/pdf',
  PLAIN_TEXT = 'text/plain',
  PNG = 'image/png',
  PPT = 'application/vnd.ms-powerpoint',
  PPTX = 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  XLS = 'application/vnd.ms-excel',
  XLSX = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
}

// The enum lists every type we can recognise; this is the narrower set 20.2.3 §3 lets a person
// upload — PDF, docx, xls/xlsx, PNG, JPEG, csv.
export const SPACE_UPLOADABLE_MIME_TYPES = [
  SpaceFileMimeType.CSV,
  SpaceFileMimeType.DOCX,
  SpaceFileMimeType.JPEG,
  SpaceFileMimeType.PDF,
  SpaceFileMimeType.PNG,
  SpaceFileMimeType.XLS,
  SpaceFileMimeType.XLSX,
] as const;

const UPLOADABLE_MIME_TYPES = new Set<string>(SPACE_UPLOADABLE_MIME_TYPES);

export const isUploadableToSpace = (contentType: string): boolean =>
  UPLOADABLE_MIME_TYPES.has(contentType);

export const SPACE_PREVIEWABLE_MIME_TYPES: readonly SpaceFileMimeType[] = [
  SpaceFileMimeType.JPEG,
  SpaceFileMimeType.PDF,
  SpaceFileMimeType.PNG,
];

export const isPreviewableInSpace = (contentType: string): boolean =>
  SPACE_PREVIEWABLE_MIME_TYPES.includes(contentType as SpaceFileMimeType);

const MIME_TYPE_BY_EXTENSION: Record<string, SpaceFileMimeType> = {
  csv: SpaceFileMimeType.CSV,
  doc: SpaceFileMimeType.DOC,
  docx: SpaceFileMimeType.DOCX,
  jpeg: SpaceFileMimeType.JPEG,
  jpg: SpaceFileMimeType.JPEG,
  pdf: SpaceFileMimeType.PDF,
  png: SpaceFileMimeType.PNG,
  ppt: SpaceFileMimeType.PPT,
  pptx: SpaceFileMimeType.PPTX,
  txt: SpaceFileMimeType.PLAIN_TEXT,
  xls: SpaceFileMimeType.XLS,
  xlsx: SpaceFileMimeType.XLSX,
};

// For a file stored without its type, as the Vault's are: read from the extension, empty when the
// extension is missing or not one we recognise.
export const spaceMimeTypeFromName = (name: string): string => {
  const dot = name.lastIndexOf('.');

  if (dot === -1) return '';

  return MIME_TYPE_BY_EXTENSION[name.slice(dot + 1).toLowerCase()] ?? '';
};
